import { ConcreteEncodable } from "./ConcreteEncodable";

import { ToggleInflightStateResultItemImplEncoder } from "../../encoder/ToggleInflightStateResultItemImplEncoder";

import * as CubiqTS from "../../index";
import { ToggleInflightStateResultItem } from "../ToggleInflightStateResultItem";

export class ToggleInflightStateResultItemImpl
  extends ConcreteEncodable
  implements ToggleInflightStateResultItem
{
  public static enType: string = "com.bcdfx.model.event.ToggleInflightStateResultItemImpl";

  /*FID=1*/
  public orderId: CubiqTS.Long | null = null;
  /*FID=2*/
  public success: boolean;
  /*FID=3*/
  public errors: CubiqTS.Errors | null = null;
  /*FID=4*/
  public orderRef: string;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = ToggleInflightStateResultItemImplEncoder.Instance;
    this.setEncodableType(ToggleInflightStateResultItemImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "ToggleInflightStateResultItemImpl[" +
      "orderId=" +
      this.orderId +
      "success=" +
      this.success +
      "errors=" +
      this.errors +
      "orderRef=" +
      this.orderRef +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
